import { Button } from "primereact/button"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { GpraContext } from "../../../context/gpraContext"

const Next = (props) => {
  const navigate = useNavigate()
  const { disabled, saveData } = props
  const { interviewType, handleActiveIndex, activeIndex, loadNext } =
    useContext(GpraContext)

  const setNextForm = (nextForm) => {
    const interview = interviewType.toLowerCase()
    navigate(`/participant/gpra-forms/${interview}/${nextForm}`)
  }
  const setNavigationItem = () => {
    let newActiveIndex = activeIndex + 1
    handleActiveIndex(newActiveIndex)
  }

  return (
    <Button
      label="Next"
      icon={loadNext ? "pi pi-spin pi-spinner" : "pi pi-arrow-right"}
      onClick={() => {
        saveData(setNextForm, false, setNavigationItem)
      }}
      disabled={disabled}
    />
  )
}

Next.propTypes = {
  saveData: PropTypes.func.isRequired,
  nextForm: PropTypes.string,
  disabled: PropTypes.bool,
}
export default Next
